import { useLocation } from "react-router-dom";

const steps = [
  { title: "Personal Details", url: "/personal-details" },
  { title: "Employment Details", url: "/employment-details" },
  { title: "Income Details", url: "/income-details" },
  { title: "Assets & Liabilities", url: "/assets-liabilities" },
  { title: "Declaration & Signatures", url: "/signatures" },
];

const LoanTypeStepper = () => {
  const { pathname } = useLocation();
  const activeIndex = steps.findIndex((step) => pathname.startsWith(step.url));

  return (
    <div className="mt-4 mb-2 ">
      {/* Desktop View */}
      <div className="hidden xl:flex items-center justify-center lg:gap-8 md:gap-4">
        {steps.map((step, index) => (
          <button
            key={step.url}
            className={`lg:px-5 lg:py-3 md:px-3 md:py-2 rounded-full border transition-all lg:text-[14px] md:text-[13px] font-Mulish text-base font-normal relative
              ${
                index === activeIndex
                  ? "bg-[#D1A960] text-white animate-pulse-wave" // Active step
                  : index < activeIndex
                  ? "bg-[#D1A960] text-white" // Previous steps
                  : "border-[#EAECF0] text-lightBlue  cursor-not-allowed" // Upcoming steps
              }`}
          >
            {step.title}
          </button>
        ))}
      </div>

      {/* Mobile View */}
      <div className="flex xl:hidden justify-between items-center  px-2">
        {steps.map((step, index) => (
          <div key={step.url}>
            {index === activeIndex ? (
              <button className="px-5 py-2 rounded-full bg-[#D1A960] text-white font-medium text-[14px] font-Mulish">
                {step.title}
              </button>
            ) : (
              <div
                className={`w-4 h-4 rounded-full  ${
                  index < activeIndex ? "bg-[#D1A960]" : "bg-[#EAECF0]"
                }`}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default LoanTypeStepper;
